module.exports = __webpack_public_path__ + "img/SLS.e2d42508.svg";